import { useAuth, useClerk } from '@clerk/react';
import { useEffect } from 'react';

interface ClerkAuthBridge {
  getToken: () => Promise<string | null>;
  signOut: () => Promise<void>;
}

let authBridge: ClerkAuthBridge | null = null;

export function getClerkToken(): Promise<string | null> {
  return authBridge?.getToken() ?? Promise.resolve(null);
}

export async function signOutOfClerk(): Promise<void> {
  await authBridge?.signOut();
}

export function ClerkAuthBridge() {
  const { getToken, isLoaded, isSignedIn, orgId, orgRole } = useAuth();
  const { signOut } = useClerk();

  useEffect(() => {
    authBridge = {
      getToken: async () => {
        if (!isLoaded || !isSignedIn) return null;
        return getToken();
      },
      signOut: async () => {
        if (isLoaded && isSignedIn) await signOut();
      },
    };

    const handleUnauthorized = () => {
      void signOut();
    };
    window.addEventListener('livinhome:auth:logout', handleUnauthorized);

    return () => {
      window.removeEventListener('livinhome:auth:logout', handleUnauthorized);
      authBridge = null;
    };
  // Refresh the bridge whenever Clerk switches the active organization. Without
  // this, requests immediately after an org switch can use a stale session
  // context and the API sends the user back to organization setup.
  }, [getToken, isLoaded, isSignedIn, orgId, orgRole, signOut]);

  return null;
}
